import { SearchHistory } from '@/types/search/SearchHistory.type'

export const ADD_LIST_RESULTS = (state: any, payload: any) => {
    const list = state.lists[payload.type]
    list.results = list.results.concat(payload.results)
    list.count = payload.count
}

export const CLEAR_LIST_RESULTS = (state: any, payload: any) => {
    const list = state.lists[payload.type]
    list.results = []
    list.count = 0
    list.firstLoaded = false
    list.currentPage = 1
}

export const INCREMENT_RESULT_PAGE = (state: any, payload: any) => {
    const list = state.lists[payload.type]
    list.currentPage++
}

export const SET_LOADING_RESULTS = (state: any, payload: any) => {
    const list = state.lists[payload.type]
    list.loading = payload.loading
}

export const SET_FIRST_LOADED_RESULTS = (state: any, payload: any) => {
    const list = state.lists[payload.type]
    if (!list.firstLoaded) {
        list.firstLoaded = true
    }
}

export const SET_SEARCH_TEXT = (state: any, searchText: string) => {
    state.searchText = searchText
}

export const SET_ACTIVE_TAB = (state: any, activeTab: string) => {
    state.activeTab = activeTab
}

export const SET_SEARCH_HISTORY_LOADING = (state: any, loading: boolean) => {
    state.history.loading = loading
}
export const SET_SEARCH_HISTORY_RESULTS = (state: any, payload: Array<SearchHistory>) => {
    state.history.results = payload
}
